// src/components/Spinner.jsx
// Shared loading indicator — replaces bare "Loading…" text with a subtle
// animated spinner + label, used consistently across every loading state
// in the app instead of each page inventing its own (or using none at all).
import { T, alpha } from '../theme/theme'

export default function Spinner({ label = 'Loading…', size = 20, color = T.or, textColor = T.mt, fontSize = '13px', inline = false }) {
  return (
    <div style={{
      display: 'flex', alignItems: 'center', justifyContent: 'center',
      gap: '10px', ...(inline ? {} : { width: '100%' }),
    }}>
      <span style={{
        display: 'inline-block', width: `${size}px`, height: `${size}px`,
        border: `2px solid ${alpha(color, 0.2)}`, borderTopColor: color,
        borderRadius: '50%', animation: 'kailux-spin 0.7s linear infinite',
        flexShrink: 0,
      }} />
      {label && <span style={{ color: textColor, fontSize }}>{label}</span>}
      <style>{`@keyframes kailux-spin { to { transform: rotate(360deg); } }`}</style>
    </div>
  )
}
